"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInstallPower = createInstallPower;
exports.deleteInstallPower = deleteInstallPower;
exports.deleteInstallPowerByUser = deleteInstallPowerByUser;
exports.getInstallPowerList = getInstallPowerList;
exports.getInstallPowerSevenDay = getInstallPowerSevenDay;
exports.getInstallPowerStatistics = getInstallPowerStatistics;
exports.updateInstallPower = updateInstallPower;

var _request = _interopRequireDefault(require("@/utils/request"));

function getInstallPowerList(params) {
  return (0, _request.default)({
    url: 'api/install-power',
    method: 'get',
    params: params
  });
}

function createInstallPower(data) {
  return (0, _request.default)({
    url: 'api/install-power',
    method: 'post',
    data: data
  });
}

function updateInstallPower(data) {
  return (0, _request.default)({
    url: 'api/install-power',
    method: 'put',
    data: data
  });
}

function deleteInstallPower(id) {
  return (0, _request.default)({
    url: "api/install-power/".concat(id),
    method: 'delete'
  });
}

function deleteInstallPowerByUser(userId) {
  return (0, _request.default)({
    url: "api/install-power/user/".concat(userId),
    method: 'delete'
  });
}

function getInstallPowerSevenDay(params) {
  return (0, _request.default)({
    url: 'api/install-power/seven-day',
    method: 'get',
    params: params
  });
}

function getInstallPowerStatistics() {
  return (0, _request.default)({
    url: 'api/install-power/statistics',
    method: 'get'
  });
}